export const SEGMENT_API_HOST = 's-api.zarla.com/v1'
